var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1669175639938,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 22473,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423.424 522.24c-6.485333 0-13.141333-2.56-18.090667-7.509333l-126.464-126.464a25.429333 25.429333 0 0 1 0-36.181334 25.429333 25.429333 0 0 1 36.181334 0l108.373333 108.373334 108.373333-108.373334c10.069333-10.069333 26.282667-10.069333 36.181334 0s10.069333 26.282667 0 36.181334l-126.464 126.464c-4.949333 4.949333-11.605333 7.509333-18.090667 7.509333z",
    "p-id": 22474
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M571.050667 564.394667h-295.253334c-14.165333 0-25.6-11.434667-25.6-25.6s11.434667-25.6 25.6-25.6h295.082667c14.165333 0 25.6 11.434667 25.6 25.6 0.170667 14.165333-11.264 25.6-25.429333 25.6zM571.050667 690.858667h-295.253334c-14.165333 0-25.6-11.434667-25.6-25.6s11.434667-25.6 25.6-25.6h295.082667c14.165333 0 25.6 11.434667 25.6 25.6s-11.264 25.6-25.429333 25.6z",
    "p-id": 22475
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.424 796.330667c-14.165333 0-25.6-11.434667-25.6-25.6V538.794667c0-14.165333 11.434667-25.6 25.6-25.6s25.6 11.434667 25.6 25.6v231.936c0 14.165333-11.434667 25.6-25.6 25.6z",
    "p-id": 22476
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M707.925333 205.653333c9.386667 0 17.066667 7.68 17.066667 17.066667v695.296c0 9.386667-7.68 17.066667-17.066667 17.066667H138.922667c-9.386667 0-17.066667-7.68-17.066667-17.066667V222.72c0-9.386667 7.68-17.066667 17.066667-17.066667h569.002666m0-51.2H138.922667c-37.717333 0-68.266667 30.549333-68.266667 68.266667v695.296c0 37.717333 30.549333 68.266667 68.266667 68.266667h568.832c37.717333 0 68.266667-30.549333 68.266666-68.266667V222.72c0.170667-37.546667-30.378667-68.266667-68.096-68.266667z",
    "p-id": 22477
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M863.402667 816.469333h-130.56v-51.2h130.56c20.992 0 38.058667-21.504 38.058666-48.128V133.632c0-26.453333-17.066667-48.128-38.058666-48.128H330.069333c-20.992 0-38.058667 21.674667-38.058666 48.128v44.714667h-51.2V133.632c0-54.784 40.106667-99.328 89.258666-99.328h533.333334c49.322667 0 89.258667 44.544 89.258666 99.328v583.509333c0 54.784-39.936 99.328-89.258666 99.328z",
    "p-id": 22478
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.53f51fe6.svg";
export { ForwardRef as ReactComponent };